import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../../config';
import { getDocsByIds } from '../../batchedIn';
import { handleFirebaseError } from '../../../error-handling';
import type { User } from '@/types';

export async function getOrganizationExaminers(organizationId: string): Promise<User[]> {
  try {
    const memberQuery = query(
      collection(db, 'organizationMembers'),
      where('organizationId', '==', organizationId),
      where('role', '==', 'examiner')
    );
    
    const memberSnapshot = await getDocs(memberQuery);
    const examinerIds = memberSnapshot.docs.map(doc => doc.data().userId);
    
    if (examinerIds.length === 0) {
      return [];
    }
    
    // Users 30 ids per query (Firestore's `in` limit): one unbatched query
    // failed once an organization had more than 30 examiners.
    const usersById = await getDocsByIds('users', examinerIds);
    const examiners = examinerIds
      .filter((id) => usersById.has(id))
      .map((id) => ({ id, ...usersById.get(id) })) as User[];

    return examiners;
  } catch (error) {
    handleFirebaseError(error, 'Error fetching organization examiners');
    return [];
  }
} 